export default __webpack_public_path__ + "static/media/Heart.93e9c47e.svg";